import { createContext } from 'react';

/**
 * True for content rendered inside the reference peek panel. Reference fields
 * render as plain read-only text there — no nested peeks or navigation links:
 * a chain of stacked panels is disorienting, and the panel is a quick look,
 * not a navigation surface (the header's Open button is the way onward).
 *
 * Lives in its own module so the consumers (LookupRenderer, EntityLookup) can
 * import it statically without pulling in the panel itself — the panel is
 * lazy-loaded from those same components.
 */
export const InsideReferencePeekContext = createContext(false);
